import { Component } from '@angular/core';

@Component({
  selector: 'a18-select-box',
  templateUrl: './a18-select-box.component.html',
  styleUrl: './a18-select-box.component.scss'
})
export class A18SelectBoxComponent {

}
